import { useContext } from 'react';
import { i18n } from 'i18n';
import ProjectContext, { IProjectContext } from './context';

export default function useProject(): IProjectContext {
  const context = useContext(ProjectContext);
  if (context === null) {
    throw new Error(i18n._('No project context available'));
  }
  return context;
}
